import { render } from "./IndexCommande.vue?vue&type=template&id=2c6fb920"
import script from "./IndexCommande.vue?vue&type=script&lang=js"
export * from "./IndexCommande.vue?vue&type=script&lang=js"

import "./IndexCommande.vue?vue&type=style&index=0&id=2c6fb920&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__